const preparedFiles = new WeakMap()
const MAX_EDGE = 2560
const JPEG_QUALITY = 0.9

async function prepare(file) {
  // Leave animated/vector formats unchanged. Unsupported camera formats also
  // fall back to the original when the browser cannot decode them.
  if (!/^image\/(jpeg|png|webp|bmp|avif|heic|heif)$/i.test(file.type)) return file
  let objectUrl
  let canvas
  let image
  try {
    objectUrl = URL.createObjectURL(file)
    image = new Image()
    await new Promise((resolve, reject) => {
      image.onload = resolve
      image.onerror = reject
      image.src = objectUrl
    })
    const width = image.naturalWidth
    const height = image.naturalHeight
    if (!width || !height) return file
    const scale = Math.min(1, MAX_EDGE / Math.max(width, height))
    canvas = document.createElement('canvas')
    canvas.width = Math.max(1, Math.round(width * scale))
    canvas.height = Math.max(1, Math.round(height * scale))
    const context = canvas.getContext('2d')
    if (!context) return file
    context.fillStyle = '#ffffff'
    context.fillRect(0, 0, canvas.width, canvas.height)
    context.drawImage(image, 0, 0, canvas.width, canvas.height)
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', JPEG_QUALITY))
    if (!blob || blob.type !== 'image/jpeg' || !blob.size || blob.size >= file.size) return file
    const name = `${file.name.replace(/\.[^.]+$/, '') || 'etiqueta'}.jpg`
    return new File([blob], name, { type: 'image/jpeg', lastModified: file.lastModified })
  } catch {
    // Optimization must never prevent a photo from being attached.
    return file
  } finally {
    if (objectUrl) URL.revokeObjectURL(objectUrl)
    if (image) { image.onload = null; image.onerror = null; image.src = '' }
    if (canvas) { canvas.width = 0; canvas.height = 0 }
  }
}

export function optimizeLabelImage(file) {
  let pending = preparedFiles.get(file)
  if (!pending) {
    pending = prepare(file).then((result) => {
      preparedFiles.set(result, Promise.resolve(result))
      return result
    })
    preparedFiles.set(file, pending)
  }
  return pending
}
